const Notfound = () => {
    return (
        <div className="notfound">
            <p>Ups! Not found</p>
        </div>
    );
}
 
export default Notfound;